<template>
  <div class="tabs-bar" @contextmenu.prevent>
    <div class="tabs-scroll">
      <div
        v-for="tab in tabs"
        :key="tab.path"
        class="tab-item"
        :class="{ active: tab.path === active }"
        @click="handleClick(tab)"
        @contextmenu.prevent="openMenu(tab, $event)"
      >
        <span class="tab-title">{{ tab.title }}</span>
        <i
          v-if="!tab.affix"
          class="el-icon-close tab-close"
          @click.stop="closeTab(tab)"
        />
      </div>
    </div>

    <!-- 右键菜单 -->
    <div
      v-if="menuVisible"
      class="tab-context-menu"
      :style="{ left: menuLeft + 'px', top: menuTop + 'px' }"
    >
      <div class="menu-item" @click="handleCloseOthers">关闭其他</div>
      <div class="menu-item" @click="handleCloseAll">关闭全部</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "TabsBar",
  data() {
    return {
      menuVisible: false,
      menuLeft: 0,
      menuTop: 0,
      menuTab: null,
    };
  },
  computed: {
    ...mapState("tabs", ["tabs", "active"]),
  },
  watch: {
    menuVisible(val) {
      if (val) {
        document.addEventListener("click", this.closeMenu);
      } else {
        document.removeEventListener("click", this.closeMenu);
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeMenu);
  },
  methods: {
    handleClick(tab) {
      if (this.$route.path !== tab.path) {
        this.$router.push(tab.path);
      }
    },

    closeTab(tab) {
      const isActive = tab.path === this.active;
      this.$store.commit("tabs/CLOSE", tab.path);
      // 如果关闭的是当前页，跳到相邻页
      if (isActive) {
        const remaining = this.tabs;
        const last = remaining[remaining.length - 1];
        if (last) this.$router.push(last.path);
        else this.$router.push("/");
      }
    },

    openMenu(tab, e) {
      this.menuTab = tab;
      this.menuLeft = e.clientX;
      this.menuTop = e.clientY;
      this.menuVisible = true;
    },

    closeMenu() {
      this.menuVisible = false;
    },

    handleCloseOthers() {
      this.menuVisible = false;
      this.$store.commit("tabs/CLOSE_OTHERS", this.menuTab.path);
      if (this.$route.path !== this.menuTab.path) {
        this.$router.push(this.menuTab.path);
      }
    },

    handleCloseAll() {
      this.menuVisible = false;
      this.$store.commit("tabs/CLOSE_ALL");
      const active = this.$store.state.tabs.active;
      if (this.$route.path !== active) {
        this.$router.push(active);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs-bar {
  position: relative;
  height: 36px;
  background: $bg-white;
  border-bottom: 1px solid $border-light;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  flex-shrink: 0;
}

.tabs-scroll {
  display: flex;
  align-items: stretch;
  height: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 4px;

  &::-webkit-scrollbar {
    height: 0;
  }
}

.tab-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  height: 100%;
  font-size: 13px;
  color: $text-regular;
  white-space: nowrap;
  cursor: pointer;
  border-right: 1px solid $border-light;
  transition: background 0.15s, color 0.15s;
  user-select: none;

  &:first-child {
    border-left: 1px solid $border-light;
  }

  &:hover {
    background: #f5f7fa;
    color: $text-primary;
  }

  &.active {
    background: #ecf5ff;
    color: $primary-color;
    font-weight: 500;

    .tab-close {
      color: $primary-color;
    }
  }

  .tab-title {
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .tab-close {
    font-size: 11px;
    color: $text-secondary;
    border-radius: 50%;
    padding: 1px;
    transition: background 0.15s, color 0.15s;

    &:hover {
      background: #c0c4cc;
      color: #fff;
    }
  }
}

.tab-context-menu {
  position: fixed;
  z-index: 9999;
  background: $bg-white;
  border: 1px solid $border-light;
  border-radius: $border-radius-base;
  box-shadow: $box-shadow-base;
  min-width: 110px;
  padding: 4px 0;

  .menu-item {
    padding: 8px 16px;
    font-size: 13px;
    color: $text-regular;
    cursor: pointer;
    transition: background 0.15s;

    &:hover {
      background: #f5f7fa;
      color: $text-primary;
    }
  }
}
</style>
